interface RefusedResponse {
  status?: number;
  data?: { data?: { message?: unknown; data?: { reason?: unknown } } };
}

/** The axios response of a failed call, as the API client rejects with it. */
const asResponse = (response: unknown): RefusedResponse =>
  (response ?? {}) as RefusedResponse;

/** The server's message for a refused call, when it sent one. */
export const refusalText = (response: unknown): string | undefined => {
  const message = asResponse(response).data?.data?.message;
  return typeof message === 'string' && message.trim() ? message : undefined;
};

/** The stable code the server attaches to a refusal (`lane_changed`, `unknown_trip`, ...). */
export const refusalReason = (response: unknown): string | undefined => {
  const reason = asResponse(response).data?.data?.data?.reason;
  return typeof reason === 'string' ? reason : undefined;
};

/** Another route search for this shipment is running, so asking again soon will succeed. */
export const isSearchInProgress = (response: unknown): boolean =>
  asResponse(response).status === 429 &&
  refusalReason(response) === 'search_in_progress';

/** The per-user rate limit, which carries no reason code. */
export const isThrottled = (response: unknown): boolean =>
  asResponse(response).status === 429 && !refusalReason(response);

/** A 4xx the server explained (not the rate limit), which asking again will not change. */
export const isClientRefusal = (response: unknown): boolean => {
  const status = asResponse(response).status ?? 0;
  return status >= 400 && status < 500 && status !== 429;
};
